var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgFavoriteStroke28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10.193L11.6022 7.79525C10.5419 6.73492 8.82273 6.73492 7.76239 7.79525L5.79525 9.7624C4.73492 10.8227 4.73491 12.5419 5.79526 13.6022L13.1915 20.9984C13.638 21.445 14.362 21.445 14.8085 20.9984L22.2047 13.6022C23.2651 12.5419 23.2651 10.8227 22.2047 9.76239L20.2376 7.79525C19.1773 6.73492 17.4581 6.73492 16.3978 7.79525L14 10.193ZM13.0164 6.38104C11.175 4.53965 8.18957 4.53965 6.34818 6.38104L4.38104 8.34818C2.53965 10.1896 2.53965 13.1751 4.38104 15.0164L11.7773 22.4127C13.0048 23.6402 14.9952 23.6402 16.2228 22.4127L23.619 15.0164C25.4603 13.1751 25.4603 10.1896 23.619 8.34818L21.6518 6.38104C19.8104 4.53965 16.825 4.53965 14.9836 6.38104L14 7.36461L13.0164 6.38104Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavoriteStroke28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;